<script setup lang="ts">
import { IEvent } from '@/enitites/event'
import { ModalWrapper } from '@/shared/ui/modals'
import { ref } from 'vue'
import PurchaseTicketsInterface from '@/features/tickets/ui/PurchaseTicketsInterface.vue'

defineProps<{
  event: IEvent
}>()

const isShowModal = ref(false)
</script>

<template>
  <BKButton
    v-if="!event.paymentSystem?.isEnabled && event.paymentSystem?.purchaseTicketsExternalUrl"
    :href="event.paymentSystem.purchaseTicketsExternalUrl"
    block
    color="var(--color-green)"
    height="48"
    white-text
  >
    Purchase Tickets
  </BKButton>
  <div v-else-if="event.paymentSystem?.isEnabled">
    <BKButton
      block
      color="var(--color-green)"
      height="48"
      white-text
      @click="isShowModal = true"
    >
      Purchase Tickets
    </BKButton>

    <ModalWrapper
      :is-show="isShowModal"
      modal-width="904px"
      @update:isShow="isShowModal = $event"
    >
      <PurchaseTicketsInterface :event-id="event.id" />
    </ModalWrapper>
  </div>
</template>
